export default {"src":"/_next/static/media/logo.1197071e.svg","height":104,"width":234,"blurWidth":0,"blurHeight":0};